import { styled } from 'styled-components'

const ErrorMessage = styled.span`
  display: inline-block;
  margin-top: -8px;
  border-radius: 3px;
  box-shadow: 0 0 2px red;
  background-color: rgb(255 220 220);
  padding: 4px 8px;
  color: red;
  font-size: 12px;
`

// const asterisks = '*✹✸✷✶✵✳︎﹡＊⩮❊❉✻✲⊛＊﹡'

const ItemValidationMessage = ({ meta }) => {
  const { errorMessage, hasBlurred, hasChanged } = meta || {}

  const show = (hasBlurred || hasChanged) && errorMessage

  return show ? <ErrorMessage>{errorMessage}</ErrorMessage> : null
}

export default ItemValidationMessage
